<span class="flex justify-center text-xs mt-8">By signing up, you agree to Plymouth Rock's
  <a class="ml-1 text-es-blue-light" href="{{terms}}" target="_blank">terms and
    conditions</a>
</span>